<template>
  <app-standard-modal
    :open="open"
    title="Verification"
    title-id="pricing-pin-verification-title"
    size="compact"
    :scrolling="false"
    append-to-body
    keyboard-aware
    @close="onCancel"
  >
    <div class="pricing-pin-verification">
      <div class="field settings" :class="{ error: !!errorMessage }">
        <app-field-label>Enter 4-digit PIN</app-field-label>
        <app-text-input
          ref="pinInput"
          variant="pin"
          :model-value="pin"
          :error="!!errorMessage"
          :disabled="submitting"
          aria-label="4-digit PIN"
          @update:model-value="onPinInput"
        />
        <app-field-error :message="errorMessage" />
      </div>
    </div>

    <template #footer>
      <div class="ui basic button smardie-btn-secondary" :class="{ disabled: submitting }" @click="!submitting && onCancel()">Cancel</div>
      <div
        class="ui right primary button"
        :class="{ loading: submitting, disabled: submitting || !canSubmit }"
        @click="onSubmit"
      >Submit</div>
    </template>
  </app-standard-modal>
</template>

<script>
import axios from 'axios'
export default {
  name: 'PricingPinVerificationModal',
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      pin: '',
      submitting: false,
      errorMessage: ''
    }
  },
  computed: {
    canSubmit: function () {
      return /^\d{4}$/.test(this.pin)
    }
  },
  watch: {
    open: function (isOpen) {
      if (isOpen) {
        this.pin = ''
        this.errorMessage = ''
        this.submitting = false
        this.$nextTick(() => {
          if (this.$refs.pinInput && this.$refs.pinInput.focus) {
            this.$refs.pinInput.focus()
          }
        })
      }
    }
  },
  methods: {
    onPinInput: function (value) {
      this.pin = value
      if (this.errorMessage) this.errorMessage = ''
      if (/^\d{4}$/.test(value)) {
        this.$nextTick(() => {
          this.onSubmit()
        })
      }
    },
    onCancel: function () {
      if (this.submitting) return
      this.$emit('close')
      this.$emit('cancel')
    },
    onSubmit: function () {
      if (this.submitting || !this.canSubmit) return
      this.submitting = true
      this.errorMessage = ''
      axios.post('/api/auth/verify-pricing-pin', { pin: this.pin })
        .then(() => {
          this.$emit('verified')
          this.$emit('close')
        })
        .catch((err) => {
          const msg = err.response && err.response.data && err.response.data.error
            ? err.response.data.error
            : 'Incorrect PIN'
          this.errorMessage = msg
          this.pin = ''
          this.$nextTick(() => {
            if (this.$refs.pinInput && this.$refs.pinInput.focus) {
              this.$refs.pinInput.focus()
            }
          })
        })
        .finally(() => {
          this.submitting = false
        })
    }
  }
}
</script>

<style scoped>
.pricing-pin-verification {
  min-width: 200px;
}

.pricing-pin-verification .field.settings {
  margin: 0 !important;
}
</style>
